import ApiService from './ApiService';

class UserCourseApi extends ApiService {

    constructor() {
        super('user-course');
    }

    getAverageScore(payload) {
        return this.get('first-test/average-score', payload);
    }
    getCoursesAndAverageScore(payload) {
        return this.get('first-test', payload);
    }
    getDataCSV(payload) {
        return this.get('first-test/export-csv', payload);
    }
    getStudentsByCourseId({id, payload}) {
        return this.get(`first-test/${id}`, payload);
    }
}

export default UserCourseApi;